<div class="range-values" *ngIf="!isDigital()">
    <!-- Very High Alarm -->
    <div *ngIf="isVeryHighAlarmEnabled()">
        <mat-icon
            class="value-bullet-point"
            svgIcon="value-pointer"
            alarmLevelColor
            [useTextClasses]="false"
            [alarmLevel]="getVeryHighAlarmLevel()"
        >
        </mat-icon>
        <span class="text">
            <span class="highlighted text">{{
                "forms.channel.alarm.alarm-labels.very-high" | translate
            }}</span>
            <span> {{ getVeryHighThreshold() }} {{ getUnits() }}</span>
        </span>
    </div>

    <!-- High Alarm -->
    <div *ngIf="isHighAlarmEnabled()">
        <mat-icon
            class="value-bullet-point"
            svgIcon="value-pointer"
            alarmLevelColor
            [useTextClasses]="false"
            [alarmLevel]="getHighAlarmLevel()"
        >
        </mat-icon>
        <span class="text">
            <span class="highlighted text">{{
                "forms.channel.alarm.alarm-labels.high" | translate
            }}</span>
            <span> {{ getHighThreshold() }} {{ getUnits() }}</span>
        </span>
    </div>

    <!-- Normal Range -->
    <div>
        <mat-icon
            class="value-bullet-point normal-range-bullet-point"
            svgIcon="value-pointer"
        >
        </mat-icon>
        <span class="text">
            <span class="highlighted">{{
                "forms.channel.alarm.alarm-labels.normal-range" | translate
            }}</span>
            <span>
                {{ getNormalMin() }} {{ getUnits() }} - {{ getNormalMax() }}
                {{ getUnits() }}</span
            >
        </span>
    </div>

    <!-- Low Alarm -->
    <div *ngIf="isLowAlarmEnabled()">
        <mat-icon
            class="value-bullet-point"
            svgIcon="value-pointer"
            alarmLevelColor
            [useTextClasses]="false"
            [alarmLevel]="getLowAlarmLevel()"
        >
        </mat-icon>
        <span class="text">
            <span class="highlighted text">{{
                "forms.channel.alarm.alarm-labels.low" | translate
            }}</span>
            <span> {{ getLowThreshold() }} {{ getUnits() }}</span>
        </span>
    </div>

    <!-- Very Low Alarm -->
    <div *ngIf="isVeryLowAlarmEnabled()">
        <mat-icon
            class="value-bullet-point"
            svgIcon="value-pointer"
            alarmLevelColor
            [useTextClasses]="false"
            [alarmLevel]="getVeryLowAlarmLevel()"
        >
        </mat-icon>
        <span class="text">
            <span class="highlighted text">{{
                "forms.channel.alarm.alarm-labels.very-low" | translate
            }}</span>
            <span> {{ getVeryLowThreshold() }} {{ getUnits() }}</span>
        </span>
    </div>
</div>
